export default __webpack_public_path__ + "static/media/Element-3.c1c9269f.png";